import { render, staticRenderFns } from "./numero-certificado.vue?vue&type=template&id=2608a0a8&scoped=true"
import script from "./numero-certificado.vue?vue&type=script&lang=js"
export * from "./numero-certificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608a0a8",
  null
  
)

export default component.exports